export default __webpack_public_path__ + "static/media/testjig4.a7fdf7b4.png";